import { ManualTypeEnum } from 'api/generated';
import { useGetManual } from 'hooks';
import { useMemo } from 'react';

import { parseBonusesManual } from './bonusCardBlocks';
import { BonusesContent, DEFAULT_BONUSES_CONTENT } from './bonuses';

/**
 * Which manual a student's bonuses come from: paid MVP members get bonus-section-upgrade (claim
 * links, coupons); everyone else gets bonus-section-default, so a free trial never even receives them.
 */
export const getBonusesManualType = (isMember: boolean) =>
  isMember ? ManualTypeEnum.BonusSectionUpgrade : ManualTypeEnum.BonusSectionDefault;

/**
 * The bonuses popup and Home banner content for a course: its bonus manual's Bonus card blocks, or
 * the shipped (free-trial-safe) defaults while it has none. Pass no course id to skip the request.
 */
export const useBonusesContent = (
  courseId: string | undefined,
  isMember: boolean,
): { bonusesContent: BonusesContent; isReady: boolean } => {
  const { content, isManualLoading } = useGetManual(getBonusesManualType(isMember), courseId);
  const authored = useMemo(() => parseBonusesManual(content), [content]);

  return {
    bonusesContent: authored ?? DEFAULT_BONUSES_CONTENT,
    // A failed request also settles, on the defaults.
    isReady: !courseId || !isManualLoading,
  };
};
